import { FaAngleLeft, FaAngleRight, FaPenToSquare } from "react-icons/fa6";
import { FiPlus, FiSearch, FiShoppingBag, FiUsers } from "react-icons/fi";
import { GiPopcorn } from "react-icons/gi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { IoDocumentOutline, IoEyeOutline } from "react-icons/io5";
import { BsCloudUpload } from "react-icons/bs";
import { MdOutlineClose } from "react-icons/md";
import { LuDollarSign } from "react-icons/lu";
import { FaArrowTrendDown } from "react-icons/fa6";
import { FaArrowTrendUp } from "react-icons/fa6";
import { MdOutlineMoreHoriz } from "react-icons/md";
import { FaStar } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa";
import { LuLayoutDashboard } from "react-icons/lu";
import { VscHistory } from "react-icons/vsc";
import { GiHandOk } from "react-icons/gi";
import { AiOutlineShoppingCart } from "react-icons/ai";
import { GiTakeMyMoney } from "react-icons/gi";
import { VscFolderOpened } from "react-icons/vsc";
import { IoImageOutline } from "react-icons/io5";
import { MdOutlineCategory } from "react-icons/md";
import { GiFamilyTree } from "react-icons/gi";
import { CiCircleList } from "react-icons/ci";

export const icons = {
  listIcon: <CiCircleList />,
  subCategoryIcon: <GiFamilyTree />,
  categoryIcon: <MdOutlineCategory />,
  bannerIcon: <IoImageOutline />,
  folderIcon: <VscFolderOpened />,
  handOkIcon: <GiHandOk />,
  cartIcon: <AiOutlineShoppingCart />,
  earningIcon: <GiTakeMyMoney />,
  historyIcon: <VscHistory />,
  dashboardIcon: <LuLayoutDashboard />,
  downIcon: <FaChevronDown />,
  rightAngleIcon: <FaAngleRight />,
  leftAngleIcon: <FaAngleLeft />,
  searchIcon: <FiSearch />,
  plusIcon: <FiPlus />,
  popcornIcon: <GiPopcorn />,
  deleteIcon: <RiDeleteBin6Line />,
  editIcon: <FaPenToSquare />,
  eyeIcon: <IoEyeOutline />,
  uploadIcon: <BsCloudUpload />,
  closeIcon: <MdOutlineClose />,
  dolarIcon: <LuDollarSign />,
  shopBagIcon: <FiShoppingBag />,
  usesIcon: <FiUsers />,
  documentIcon: <IoDocumentOutline />,
  trendUpIcon: <FaArrowTrendUp />,
  trendDownicon: <FaArrowTrendDown />,
  moreIcon: <MdOutlineMoreHoriz />,
  starIcon: <FaStar />,
};
